import React, { Component } from 'react';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import AccountServices from '../../services/axioServices/apiServices/AccountServices.js';

class OpeningBalanceReport extends Component {
    constructor(props) {
        super(props);
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.accountServices = new AccountServices();
        this.state = {
            tableStatus: "",
            filterDetails: {
                orderBy: "partyName",
                partyName: ""
            },
            openingBalanceList: [],
            orderByList: [
                { orderBy: "Account Name", value: "partyName" },
                { orderBy: "Group Name", value: "groupName" },
            ],
            pricing: {
                totalCreditAmount: 0,
                totalDebitAmount: 0,
                creditOpenBalDifference: 0,
                debitOpenBalDifference: 0,
                finalCreditAmount: 0,
                fianlDebitAmount: 0
            }
        };
    }

    componentDidMount() {
        this.getAllOpeningBalanceReport()
    }

    getAllOpeningBalanceReport = () => {
        this.setState({ tableStatus: "Loading..." }, () => {
            let request = this.state.filterDetails
            this.accountServices.getAllOpeningBalanceReport(request).then((response) => {
                if (response.statusCode === 200 && response.responseData != null) {
                    let res = response.responseData
                    res.map(party => {
                        party.debit = party.openBalanceDRCR.toLowerCase() === "dr" ? party.openBalance : 0
                        party.credit = party.openBalanceDRCR.toLowerCase() === "cr" ? party.openBalance : 0
                    })
                    if (response.responseData.length === 0) {
                        this.setState({ tableStatus: "No Record Found" })
                    } else {
                        this.setState({ tableStatus: "" })
                    }
                    this.setState({ openingBalanceList: res }, () => {
                        this.calculateTotals()
                    })
                } else {
                    this.setState({ tableStatus: "" })
                    this.SwalServices.Error(response.Message);
                }
            });
        })
    }

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.filterDetails;
        details[name] = value.toUpperCase();
        this.setState({ filterDetails: details }, () => {
            this.getAllOpeningBalanceReport()
        });
    };

    calculateTotals = () => {
        let list = this.state.openingBalanceList
        let totalCreditAmount = list.reduce((sum, item) => sum + Number(item.credit), 0);
        let totalDebitAmount = list.reduce((sum, item) => sum + Number(item.debit), 0);
        let details = this.state.pricing
        details.totalCreditAmount = totalCreditAmount
        details.totalDebitAmount = totalDebitAmount
        if (totalCreditAmount > totalDebitAmount) {
            details.debitOpenBalDifference = totalCreditAmount - totalDebitAmount
        } else {
            details.creditOpenBalDifference = totalDebitAmount - totalCreditAmount
        }
        details.fianlDebitAmount = details.debitOpenBalDifference + details.totalDebitAmount
        details.finalCreditAmount = details.creditOpenBalDifference + details.totalCreditAmount
        this.setState({ pricing: details })
    }

    handleDropDownChange = (event, name) => {
        const select = event.target.value;
        let details = this.state.filterDetails;
        details[name] = select;
        this.setState({ filterDetails: details });
    };

    render() {
        return (
            <div>
                <div className="item-search flex gap-2.5 !mb-3">
                    <div className="search-grp w-[35%]">
                        <label>Party Name</label>
                        <input
                            type="text"
                            id="partyName"
                            name="partyName"
                            className="inputFocus"
                            autocomplete="off"
                            value={this.state.filterDetails.partyName}
                            onChange={(event) =>
                                this.handleChange(event, "partyName")
                            }
                        />
                    </div>
                    <div className="search-grp w-[20%]">
                        <label>Order By</label>
                        <select
                            name="orderBy"
                            className="w-full"
                            value={this.state.filterDetails.orderBy
                                && this.state.filterDetails.orderBy !== 'Select'
                                && this.state.orderByList.find((party) => party.value === this.state.filterDetails.orderBy).value}
                            onChange={(event) =>
                                this.handleDropDownChange(
                                    event,
                                    "orderBy",
                                    "filterDetails"
                                )
                            }
                        >
                            {this.state.orderByList.map((x, key) => (
                                <option key={key} value={x.value}>
                                    {x.orderBy}
                                </option>
                            ))}
                        </select>
                    </div>
                    {this.state.openingBalanceList > 0 ? <button
                        className="print-btn mt-auto"
                        onClick={() => this.getAllAccountLedger()}>
                        Print
                    </button> : null}
                </div>
                <div class="item-listing">
                    <div class="itemList-table ">
                        <div class="table-container" style={{ height: "calc(100vh - 310px)" }} >
                            <table class="itemList">
                                <thead>
                                    <tr>
                                        <td className='w-[30%]'>Account Name</td>
                                        <td className='w-[30%]'>Group Name</td>
                                        <td className='w-[20%]'>Debit</td>
                                        <td className='w-[20%]'>Credit</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.openingBalanceList && this.state.openingBalanceList.length > 0 ? (
                                        this.state.openingBalanceList.map((details, key) => (
                                            <tr
                                                className="hover:bg-gray-200"
                                                key={key}
                                            >
                                                <td>{details.partyName}</td>
                                                <td>{details.accountGroupName}</td>
                                                <td>{details.debit > 0 ? details.debit : ''}</td>
                                                <td>{details.credit > 0 ? details.credit : ''}</td>
                                            </tr>
                                        ))
                                    ) : this.state.openingBalanceList &&
                                        this.state.openingBalanceList.length === 0
                                        && this.state.tableStatus !== "" ? (
                                        <tr>
                                            <td colSpan={4} style={{ textAlign: "center", fontSize: "16px" }}>
                                                {this.state.tableStatus}
                                            </td>
                                        </tr>
                                    ) : this.state.openingBalanceList &&
                                        this.state.openingBalanceList.length === 0
                                        && this.state.tableStatus === "" ? null : ""}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="item-sections w-[600px] rounded-[10px] ml-auto mt-3 !p-3  !bg-white " style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', backgroundColor: "#f5f5f5" }}>
                    <div className="search-grp flex gap-2">
                        <div className="w-[25%] !flex !items-center !text-[14px] !font-medium !text-[#585858] pt-[16px]">
                            Total
                        </div>
                        <div className='flex gap-2.5 w-[75%]'>

                            <div className=" w-full">
                                <label>Debit</label>
                                <input
                                    className='h-[36px]'
                                    type="number"
                                    id="grandTotal"
                                    name="grandTotal"
                                    autocomplete="off"
                                    disabled
                                    value={this.state.pricing.totalDebitAmount ? this.state.pricing.totalDebitAmount : 0}

                                />
                            </div>
                            <div className=" w-full">
                                <label>Credit</label>
                                <input
                                    className='h-[36px]'
                                    type="number"
                                    id="grandTotal"
                                    name="grandTotal"
                                    autocomplete="off"
                                    disabled
                                    value={this.state.pricing.totalCreditAmount ? this.state.pricing.totalCreditAmount : 0}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="search-grp flex gap-2 mt-[10px]">
                        <div className="w-[25%] !flex !items-center  !text-[14px] !font-medium !text-[#585858]">
                            Opn. Bal. Difference
                        </div>

                        <div className='flex gap-2.5 w-[75%]'>
                            <input
                                className='h-[36px]'
                                type="number"
                                id="grandTotal"
                                name="grandTotal"
                                autocomplete="off"
                                disabled
                                value={this.state.pricing.debitOpenBalDifference ? this.state.pricing.debitOpenBalDifference : 0}
                            />
                            <input
                                className='h-[36px]'
                                type="number"
                                id="grandTotal"
                                name="grandTotal"
                                autocomplete="off"
                                disabled
                                value={this.state.pricing.creditOpenBalDifference ? this.state.pricing.creditOpenBalDifference : 0}
                            />
                        </div>
                    </div>

                    <div className="search-grp flex gap-2.5 mt-[10px]">
                        <div className="w-[25%] !flex !items-center !text-[15px] font-bold !text-[rgb(62 62 62)] ">
                            Total
                        </div>
                        <div className='flex gap-2.5 w-[75%]'>
                            <input
                                className='h-[36px]'
                                type="number"
                                id="grandTotal"
                                name="grandTotal"
                                autocomplete="off"
                                disabled
                                value={this.state.pricing.fianlDebitAmount ? this.state.pricing.fianlDebitAmount : 0}
                            />
                            <input
                                className='h-[36px]'
                                type="number"
                                id="grandTotal"
                                name="grandTotal"
                                autocomplete="off"
                                disabled
                                value={this.state.pricing.finalCreditAmount ? this.state.pricing.finalCreditAmount : 0}
                            />
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default OpeningBalanceReport;